import script from "./ViewManualAppraisalsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewManualAppraisalsPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewManualAppraisalsPage.vue?vue&type=style&index=0&id=0fb890b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fb890b0"]])

export default __exports__